export default {"src":"/_next/static/media/digit-icon.81974f8a.svg","height":43,"width":43,"blurWidth":0,"blurHeight":0};